<template>
  <!-- <el-dialog
    custom-class="detail-dialog"
    :title="$t('message.home.returnApply')"
    :visible.sync="dialogVisible"
  > -->
  <div class="info_page_container" style="width: 480px" v-loading="loading">
    <div
      class="page-title"
      style="cursor: pointer; margin-bottom: 20px"
      @click="goBack"
    >
      <i class="el-icon-arrow-left"></i> {{ $t("message.home.myOrder") }}/{{
        $t("message.home.returnApply")
      }}
    </div>
    <el-form
      :model="model"
      :rules="rules"
      ref="returnForm"
      label-position="top"
    >
      <el-form-item
        :label="$t('message.home.returnReason')"
        prop="returnReason"
      >
        <el-select
          v-model="model.returnReason"
          :style="{ width: '100%' }"
          :placeholder="$t('message.home.cancelOrderTitle')"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('message.home.returnAmount')" prop="money">
        <el-input
          disabled
          :value="numberFormat(model.money)"
          :placeholder="$t('message.home.pleaseInput')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('message.home.returnRemark')"
        prop="returnDetail"
      >
        <el-input
          v-model="model.returnDetail"
          class="content"
          type="textarea"
          :placeholder="$t('message.home.pleaseInput')"
          resize="none"
          :maxlength="120"
        />
      </el-form-item>
    </el-form>
    <div>
      <el-button
        size="medium"
        style="width: 480px; height: 44px"
        type="primary"
        :loading="loading"
        @click="confirmEvent"
      >
        {{ $t("message.home.确认") }}
      </el-button>
    </div>
  </div>

  <!-- </el-dialog> -->
</template>

<script>
import { mapActions } from "vuex";
import common from "@/util/common";
import { numberFormat } from "@/util";
import { refunds } from "@/api/order/refunds.js";
//////////////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////////////
export default {
  name: "order-detail-dialog",
  props: {
    // value: {
    //     type: Boolean,
    //     default: false,
    // },
    // currentOrderInfo: {
    //     type: Object,
    //     default: () => { },
    // },
    refresh: {
      type: Function,
    },
  },
  data() {
    const { currentOrder: currentOrderInfo = {} } = this.$route.params;
    const resolveRefundAmount = (order = {}) => {
      const amount = order.amount ?? order.priceCount ?? order.prizeReal ?? order.price;
      return Number(amount) || 0;
    };
    return {
      currentOrderInfo,
      dialogVisible: this.value || false,
      loading: false,
      model: {
        returnReason: "",
        money: resolveRefundAmount(currentOrderInfo),
        returnDetail: "",
      },
      rules: {
        returnReason: [common.ruleUtils.getRule("required")],
        money: [common.ruleUtils.getRule("required")],
        // returnDetail: [
        //   common.ruleUtils.getRule("required"),
        // ],
      },
      options: [
        {
          label: this.$t("message.home.cancelOrder1"),
          value: 1,
        },
        {
          label: this.$t("message.home.cancelOrder2"),
          value: 2,
        },
        {
          label: this.$t("message.home.cancelOrder3"),
          value: 3,
        },
        {
          label: this.$t("message.home.cancelOrder4"),
          value: 4,
        },
        {
          label: this.$t("message.home.cancelOrder5"),
          value: 5,
        },
        {
          label: this.$t("message.home.cancelOrder6"),
          value: 6,
        },
        {
          label: this.$t("message.home.cancelOrder7"),
          value: 7,
        },
        {
          label: this.$t("message.home.cancelOrder8"),
          value: 8,
        },
        {
          label: this.$t("message.home.cancelOrder9"),
          value: 9,
        },
      ],
  //////////////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////////////
    };
  },
  watch: {
    // currentOrderInfo(val) {
    //     // this.dialogVisible = val;
    //     if (val) {
    //         this.model.money = this.currentOrderInfo.prizeReal;
    //     }
    // },
    // dialogVisible(val) {
    //     if (val !== this.value) {
    //         this.$emit("input", val);
    //     }
    // },
  },
  mounted() {
    const currentOrder = this.$route.params.currentOrder;
    if (currentOrder) {
      this.model.money = this.resolveRefundAmount(currentOrder);
    }
  },
  methods: {
    resolveRefundAmount(order = {}) {
      const amount = order.amount ?? order.priceCount ?? order.prizeReal ?? order.price;
      return Number(amount) || 0;
    },
    buildRefundReason() {
      const selected = this.options.find((item) => item.value === this.model.returnReason);
      const reasonLabel = selected ? selected.label : String(this.model.returnReason || "");
      return this.model.returnDetail
        ? `${reasonLabel}: ${this.model.returnDetail}`
        : reasonLabel;
    },
    async submitRefundRequest() {
      const order = this.currentOrderInfo;
      const orderItems = order.orderItems || [];
      if (!order.id || !orderItems.length) {
        throw new Error("missing order items");
      }
      const reason = this.buildRefundReason();
      for (const item of orderItems) {
        const formData = {
          method: "2",
          reason,
        };
        const params = {
          orderId: order.id,
          orderItemId: item.id,
          quantity: Number(item.quantity) || 1,
        };
        const response = await refunds(formData, params);
        if (response?.data?.code != null && response.data.code !== 0) {
          throw new Error(response.data.message || "refund failed");
        }
      }
    },
    ...mapActions({
      requestGetUserBalanceList: "user/requestGetUserBalanceList",
    }),
    numberFormat,
    goBack() {
      this.$router.push("/userInfo/my-order");
    },
    async requestData() {
      this.$refs.returnForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            await this.submitRefundRequest();

            this.$notify({
              title: this.$t("message.home.successTips"),
              message: this.$t("message.home.returnOrderSuccess"),
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit("closeDetails");
            this.refresh && this.refresh();
            this.requestGetUserBalanceList();
            this.$router.push("/userInfo/my-order");
          } catch (error) {
            const serverMsg = error?.response?.data?.message;
            this.$message.error(serverMsg || this.$t("message.home.提交失败") || error.message);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    confirmEvent() {
      this.requestData();
    },
    cancelEvent() {
      this.dialogVisible = false;
    },
  
//////////////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////////////
  },
};
</script>

<style lang="scss" scoped>
.order-item {
  .item {
    margin-bottom: 20px;

    .el-select {
      width: 100%;
    }
  }
}
</style>
